import React from 'react';
import { Icon as IconDto } from '../../types/dtos/icon.dto';
import Icon from '../Icon';

interface OpenSiteIconProps {
  icon: IconDto;
  size?: 'small' | 'large';
  color?: string;
}

const OpenSiteIcon: React.FC<OpenSiteIconProps> = ({ icon, size = 'small', color = 'medium', ...rest }) => {
  return <Icon icon={icon} size={size} color={color} {...rest} />;
};

export default OpenSiteIcon;
